import { useState, useEffect } from "react";
import { Input } from "reactstrap";

const SwitchInp = (props) => {
  const { enabled = false, handleChangeFun, name, id } = props;
  const [enabledState, setEnabledState] = useState(enabled);

  useEffect(() => {
    setEnabledState(enabled);
  }, [enabled]);

  return (
    <Input type="checkbox" id={id}
                    checked={enabledState}
                    name="pps"  onChange={() =>
        handleChangeFun((prev) => ({
          ...prev,
          [name]: !enabledState,
        }))
      }/>
    // <Input
    //   className="common_checkbox abc"
    //   type="checkbox"
    //   id={id}
    //   checked={enabledState}
    //   onChange={() =>
    //     handleChangeFun((prev) => ({
    //       ...prev,
    //       [name]: !enabledState,
    //     }))
    //   }
    // /> 

  );
};

export default SwitchInp;
